import { color, MixinStyle } from '@license-admin/boldjobs';
import Mixin from '@styles/mixin';
import styled, { css, keyframes } from 'styled-components';

const filterShimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

export const FlyerWrapper = styled.div<{ toggleFlyer?: boolean }>`
  z-index: 99;
  height: calc(100vh - 5rem);
  ${MixinStyle.PositionStyle('5rem', 0, 0, 0, 'fixed')};
  overflow: hidden;
  transform: ${({ toggleFlyer }) =>
    toggleFlyer ? 'translate3d(0, 0, 0)' : 'translate3d(0, -100%, 0)'};
  will-change: transform;
  backface-visibility: hidden;
  contain: layout style paint;
  visibility: ${({ toggleFlyer }) => (toggleFlyer ? 'visible' : 'hidden')};
  pointer-events: ${({ toggleFlyer }) => (toggleFlyer ? 'auto' : 'none')};
  ${({ theme: { FilterBtnStyle } }) =>
    FilterBtnStyle &&
    css`
      background-color: ${FilterBtnStyle.BgColors.flyerwrapbg};
    `}
  display: grid;
  grid-template-rows: auto 1fr auto;
`;
export const FlyerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1.5rem 0;
  padding: 2.2rem 1.5rem 0;
  align-items: center;
  .reset_btn {
    padding: 0;
    text-align: left;
    min-width: 10%;
  }
  .flyerCross {
    padding: 0;
    text-align: right;
    min-width: 10%;
  }
  ${({ theme: { FilterBtnStyle } }) =>
    FilterBtnStyle &&
    css`
      .reset_btn {
        font-size: ${FilterBtnStyle.FontSizes.resetcrossbtn};
      }
      .flyerCross {
        font-size: ${FilterBtnStyle.FontSizes.resetcrossbtn};
        color: ${FilterBtnStyle.Colors.crossiconcolor};
      }
    `}
`;
export const FilterText = styled.span`
  text-align: center;
  ${({ theme: { FilterBtnStyle } }) =>
    FilterBtnStyle &&
    css`
      font-size: ${FilterBtnStyle.FontSizes.filtertexthead};
    `}
`;

export const FlyerBody = styled.div`
  margin: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  content-visibility: auto; /* Progressive enhancement — skips rendering for off-screen content */
  contain: layout paint;
`;
export const FlyerFooter = styled.div`
  padding: 1.5rem 1.2rem;
  ${({ theme: { FilterBtnStyle } }) =>
    FilterBtnStyle &&
    css`
      .show-jobs-btn {
        background-color: ${FilterBtnStyle.BgColors.showJobs};
        border-color: ${FilterBtnStyle.BdrColors.showJobs};
      }
      background-color: ${FilterBtnStyle.BgColors.flyerfooterbg};
    `}
`;
export const FilterListWrap = styled.div`
  padding: 1.5rem;

  ${({ theme: { FilterBtnStyle } }) =>
    FilterBtnStyle &&
    css`
      border-bottom: 0.1rem solid ${FilterBtnStyle.BdrColors.filterBdr};
    `}
`;

export const MobSortFilterWrap = styled.div`
  ${Mixin.VerticalCenter()};
  padding: 1.5rem;

  .sort-btn {
    padding: 0.6rem 0.8rem;
  }

  ${({ theme: { FilterBtnStyle } }) =>
    FilterBtnStyle &&
    css`
      border-bottom: 0.1rem solid ${FilterBtnStyle.BdrColors.filterBdr};
    `}
`;
export const CloseButton = styled.button`
  color: ${color('color-40')};
  border: 0;
  background: transparent;
  min-width: 4.4rem;
  min-height: 4.4rem;
  touch-action: manipulation;
`;

export const FlyerSkeletonList = styled.div`
  padding: 0 1.5rem 1.5rem;
`;

export const FlyerSkeletonItem = styled.div`
  padding: 1.4rem 0;
  border-bottom: 0.1rem solid ${color('color-95')};
`;

export const FlyerSkeletonLine = styled.div<{
  width?: string;
  height?: string;
}>`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '1.2rem'};
  border-radius: 0.4rem;
  background: linear-gradient(
    90deg,
    ${color('color-95')} 0%,
    ${color('color-90')} 40%,
    ${color('color-95')} 80%
  );
  background-size: 220% 100%;
  animation: ${filterShimmer} 1.2s ease-in-out infinite;

  & + & {
    margin-top: 1rem;
  }
`;
